export interface GableWorkflowActionOption {
    value: string;
    label: string;
    group?: string;
    description?: string | null;
}

const ACTION_TYPES = [
    'adjust_budget', 'adjust_charge', 'approve_amenity_booking', 'approve_payable', 'approve_request', 'approve_transactions',
    'archive_records', 'cancel_amenity_booking', 'cancel_mail', 'categorize_transaction', 'close_ballot', 'close_survey',
    'convert_bank_rec_missing_items', 'create_and_apply_tag', 'create_ballot', 'create_calendar_event', 'create_charge', 'create_draft_budget',
    'create_journal_entry', 'delete_charges', 'delete_unit_photos', 'delete_violations', 'email_board_summary',
    'email_charge_invoices', 'email_unit_owners', 'export_communications', 'forgive_charges', 'issue_account_credit',
    'manage_account', 'manage_amenity', 'manage_amenity_booking', 'manage_amenity_schedule', 'manage_amenity_share_email',
    'manage_ballot', 'manage_ballot_questions', 'manage_ballot_setup', 'manage_calendar_event', 'manage_category',
    'manage_charges', 'manage_custom_fields', 'manage_custom_report_template', 'manage_deposit_payment_links',
    'manage_documents', 'manage_email', 'manage_form', 'manage_form_submission', 'manage_form_submission_notes',
    'manage_inbox_conversation', 'manage_members', 'manage_message_board', 'manage_notes', 'manage_notifications',
    'manage_owner_registrations', 'manage_payable', 'manage_payable_approval_settings', 'manage_payable_inbox', 'manage_payment',
    'manage_recurring_charge_template', 'manage_report_packet', 'manage_resale_documents', 'manage_resale_order',
    'manage_submission_statuses', 'manage_survey', 'manage_tags', 'manage_task', 'manage_task_bids', 'manage_task_vendor_access',
    'manage_transaction', 'manage_transaction_rule', 'manage_unit', 'manage_unit_occupancy', 'manage_vendor_payment',
    'manage_violation', 'manage_violation_comments', 'manage_violation_statuses', 'manage_violation_templates',
    'manage_voting_templates', 'payable_match', 'post_message_board_thread', 'rebuild_general_ledger', 'reconcile_bank_statement',
    'record_offline_payments', 'record_transfer', 'reply_to_invoice', 'reply_to_request', 'reply_to_violation',
    'reschedule_amenity_booking', 'resend_membership_activation', 'return_payments', 'send_ballot_reminder', 'send_email',
    'send_payment_reminder', 'send_sms', 'send_survey', 'send_template_email', 'send_violation_notice', 'set_request_status',
    'share_ballot_results', 'share_documents', 'split_transaction', 'transfer_match', 'update_violation_resolve_by',
    'update_violation_status',
];

export function actionTypeLabel(type: string): string {
    const text = type.replace(/_/g, ' ');
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export const GABLE_WORKFLOW_ACTION_OPTIONS: GableWorkflowActionOption[] = ACTION_TYPES.map((value) => ({ value, label: actionTypeLabel(value) }));
